/* const memberData = [
  {name:'Manimalavan',email:'manimalavanazero@gmail.com',phone:234567891,company:'Magizham garden',spaceused:'20Gb',icon:'/assets/M.png'},
   {name:'Bala',email:'balaazero@gmail.com',phone:234567891,company:'Ben Motor',spaceused:'20Gb',icon:'/assets/B.png'},
] */

   const memberData = [
  {
    _id:1,
    name: 'Manimalavan',
    email: 'manimalavanazero@gmail.com',
    phone: 234567891,
    company: 'Magizham Garden',
    spaceused: '20GB',
    icon: '/assets/M.png',
    
  },
  { 
    _id:2,
    name: 'Bala',
    email: 'balaazero@gmail.com',
    phone: 234567892,
    company: 'Ben Motor',
    spaceused: '20GB',
    icon: '/assets/B.png',
  },
];

export default memberData;
